<template>
  <div v-loading="loading" class="rj-page-card">
    <div class="rj-page-card__title">
      收货信息
    </div>
    <div class="rj-page-card__content">
      <Collapse :open="true">
        <div slot="header">
          <span>配送至：</span>
          <div v-if="address && this.form.receiptAddressId" class="adressBox">
            <div v-if="address.isDefault" class="defTab">
              默认
            </div>
            <div class="item">
              {{ address.receiverName }}
            </div>
            <div class="item">
              {{ address.province }}
            </div>
            <div class="item">
              {{ address.city }}
            </div>
            <div class="item">
              {{ address.county }}
            </div>
            <div class="item">
              {{ address.receiptAddress }}
            </div>
            <div class="item">
              {{ address.receiverPhone }}
            </div>
          </div>
          <el-button v-if="address && address.receiverName" type="text" style="padding: 0;margin-left: 15px" @click.stop="showAddress=true">
            更改地址
          </el-button>
          <el-button v-else type="text" style="padding: 0;margin-left: 15px" @click.stop="showAddress=true">
            选择地址
          </el-button>
        </div>
        <slot name="freightInfo" />
        <div style="padding: 20px">
          <p v-if="CustomizationList.length" style="padding: 10px 0;color: red">
            此单涉及定制化产品，具体型号为：
            <el-tag v-for="(item,index) in CustomizationList" :key="index">
              {{ item.productName }}
            </el-tag>
            下单时请代理商支付此合同全部货款的30%进行下单，有疑问，请联系对应销售。
          </p>
          <el-form :inline="true">
            <el-form-item v-if="!(departmentCode && (departmentCode.includes('000063') || departmentCode.includes('000036') || departmentCode.includes('000101')))">
              <el-date-picker v-model="allAttribute.time" type="date" value-format="yyyy-MM-dd" placeholder="选择期望发货日期" />
            </el-form-item>
            <el-form-item>
              <el-select v-model="allAttribute.freight" placeholder="请选择货运属性">
                <el-option
                  v-for="(value, key) in freightProperty"
                  :key="key"
                  :label="value"
                  :value="key"
                />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="batchSettings">
                批量设置
              </el-button>
              <el-button type="primary" @click="setMaterialNum()">
                设置料号
              </el-button>
            </el-form-item>
          </el-form>
          <div class="">
            <el-table
              :data="productList"
              border
              style="width: 100%"
              show-summary
              :summary-method="getSummaries"
              :height="tableHeight"
            >
              <el-table-column
                fixed
                type="index"
                label="序号"
                align="left"
              />
              <el-table-column
                fixed
                prop="productCode"
                label="销售代码"
                align="left"
              />
              <el-table-column
                fixed
                prop="productName"
                label="产品型号"
                align="left"
                width="300"
              >
                <template v-slot="{row}">
                  <choose-product :row="row" :form="form" />
                </template>
              </el-table-column>
              <el-table-column
                fixed
                prop="productCode"
                label="料号"
                align="left"
                width="130"
              >
                <template v-slot="{row,$index}">
                  <el-button
                    type="text"
                    :disabled="row.exclusiveMaterialNumber!==''
                      &&row.exclusiveMaterialNumber!==null"
                    @click="setMaterialNum(row,$index)"
                  >
                    {{ row.materialNumberId?row.materialNumberId:'选择料号' }}
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column
                fixed
                prop="serviceLife"
                label="数量"
                align="left"
              >
                <template v-slot="{row}">
                  <el-input-number
                    v-model="row.serviceLife"
                    :min="0"
                    :controls="false"
                    style="width:100%;"
                    @change="handleChange"
                  />
                </template>
              </el-table-column>
              <el-table-column
                prop="unit"
                label="单位"
                width="100"
                align="left"
              />
              <el-table-column
                prop="productPriceSigle"
                label="单价"
                align="left"
              >
                <template v-slot="{row}">
                  <el-input-number
                    v-model="row.productPriceSigle"
                    :min="0"
                    :controls="false"
                    style="width:100%;"
                    @change="handleChange"
                  />
                </template>
              </el-table-column>
              <el-table-column
                prop="orderAmount"
                label="订单金额"
                width="110"
                align="right"
                header-align="left"
              >
                <template v-slot="{row}">
                  <el-input-number
                    v-model="row.orderAmount"
                    :precision="6"
                    :step="0.01"
                    :min="0"
                    :controls="false"
                    style="width:100%;"
                  />
                </template>
              </el-table-column>
              <el-table-column
                prop="settlementAmount"
                label="实际结算金额"
                width="110"
                align="right"
                header-align="left"
              >
                <template v-slot="{row}">
                  <el-input-number
                    v-model="row.settlementAmount"
                    :precision="6"
                    :step="0.01"
                    :min="0"
                    :controls="false"
                    style="width:100%;"
                  />
                </template>
              </el-table-column>
              <el-table-column
                prop="beforeSplitProductPriceSigle"
                label="拆分前单价"
                align="right"
                header-align="left"
              >
                <template v-slot="{row}">
                  <el-input-number
                    v-if="row.addNew || (form && form.isNewContract)"
                    v-model="row.beforeSplitProductPriceSigle"
                    :min="0"
                    :controls="false"
                    style="width:100%;"
                  />
                  <span v-else>
                    {{ row.beforeSplitProductPriceSigle }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                prop="isBorrow"
                label="测试借条转订单"
                align="left"
                width="110"
              >
                <template v-slot="{row,$index}">
                  <el-checkbox v-model="row.isBorrow" @change="clickBorrow(row,$index)" />
                </template>
              </el-table-column>
              <el-table-column
                prop="pname"
                label="货运属性"
                align="left"
                width="120"
              >
                <template v-slot="{row}">
                  <el-select
                    v-model="row.freightProperty"
                    placeholder="货运属性"
                  >
                    <el-option
                      v-for="(value, key) in freightProperty"
                      :key="key"
                      :label="value"
                      :value="key"
                    />
                  </el-select>
                </template>
              </el-table-column>
              <!-- <el-table-column
                prop="expectedDeliveryDate"
                label="期望发货日期"
                align="left"
                width="150"
              >
                <template v-slot="{row}">
                  <el-date-picker
                    v-model="row.expectedDeliveryDate"
                    type="date"
                    style="width:100%;"
                    value-format="yyyy-MM-dd"
                    placeholder="期望发货日期"
                    :clearable="false"
                  />
                </template>
              </el-table-column> -->
              <template v-if="departmentCode && (departmentCode.includes('000063') || departmentCode.includes('000036') || departmentCode.includes('000101'))">
                <el-table-column
                  prop="expectedDeliveryDate"
                  label="期望齐套日期"
                  align="left"
                >
                  <template v-slot="{row}">
                    {{ row.expectedDeliveryDate ? row.expectedDeliveryDate : '——' }}
                  </template>
                </el-table-column>
              </template>
              <template v-if="departmentCode && (departmentCode.includes('000063') || departmentCode.includes('000036') || departmentCode.includes('000101'))">
                <el-table-column
                  prop="expectedShippingDate"
                  label="期望发货日期"
                  align="left"
                >
                  <template v-slot="{row}">
                    {{ row.expectedShippingDate ? row.expectedShippingDate : '——' }}
                  </template>
                </el-table-column>
              </template>
              <template v-if="departmentCode && (departmentCode.includes('000063') || departmentCode.includes('000036') || departmentCode.includes('000101'))">
                <el-table-column
                  prop="expectedArrivalDate"
                  label="期望到货日期"
                  align="left"
                >
                  <template v-slot="{row}">
                    {{ row.expectedArrivalDate ? row.expectedArrivalDate : '——' }}
                  </template>
                </el-table-column>
              </template>
              <template v-if="!(departmentCode && (departmentCode.includes('000063') || departmentCode.includes('000036') || departmentCode.includes('000101')))">
                <el-table-column
                  prop="expectedDeliveryDate"
                  label="期望发货日期"
                  align="left"
                  width="150"
                >
                  <template v-slot="{row}">
                    <el-date-picker
                      v-model="row.expectedDeliveryDate"
                      type="date"
                      style="width:100%;"
                      value-format="yyyy-MM-dd"
                      placeholder="期望发货日期"
                      :clearable="false"
                    />
                  </template>
                </el-table-column>
              </template>
            </el-table>
          </div>
        </div>
      </Collapse>
      <slot />
    </div>
    <address-box
      :prop-open.sync="showAddress"
      @chooseAddress="changeAddress"
      @ChangeDatas="ChangeDatas"
    />
    <material-num
      ref="MaterialNum"
      @chooseMateria="chooseMateria"
    />
  </div>
</template>

<script type="es6">
import Collapse from '@/components/Collapse';
import chooseProduct from '../../contractCommonInput/chooseProduct';
import MaterialNum from '../../contractCommonInput/MaterialNum';
import addressBox from '@/views/address/index.vue';
import { mapState } from 'vuex';
import { MathMulti, MathAdd, DateToStr } from '@/libs/util';
import { getReceiptAddressInfoModel } from '@/API';
import eventBus from '@/libs/eventBus.js';

export default {
  data () {
    return {
      allAttribute: {
        time: '',
        freight: ''
      },
      productList: [],
      showAddress: false,
      loading: false,
      address: {},
      tableHeight: 400,
      powerCordData: {},
      isShowInternationalServiceOrders: 0, // 是否是国际服务订单,0国内,1国际,用于控制电源线字段是否显示
      departmentCode: '' // 部门编码
    };
  },
  props: {
    communicationOrderDiscount: {
      type: [String, Number],
      default: 1
    },
    rebateAmount: {
      type: [String, Number],
      default: 0
    },
    rebate: {
      type: [Number],
      default: 1
    },
    salesType: {
      type: [String, Number],
      default: ''
    },
    isTestProject: {
      type: [Boolean, Number],
      default: false
    },
    contractType: {
      type: String,
      default: ''
    },
    form: {
      type: Object,
      default: () => { return {}; }
    }
  },
  components: {
    Collapse,
    addressBox,
    chooseProduct,
    MaterialNum
  },
  computed: {
    // 定制化产品
    CustomizationList () {
      return this.productList.filter((item) => {
        return item.customizationOrNot;
      });
    },
    ...mapState({
      freightProperty: state => state.enumeration.freightProperty
    }),
    // 数量总计
    AmountTotal () {
      let cont = 0;
      this.productList.forEach((item) => {
        if (item.serviceLife) {
          cont += item.serviceLife;
        }
      });
      cont = Number(cont).toFixed(2);
      return cont;
    },
    // 订单金额总计
    computePriceTotal () {
      let cont = 0;
      this.productList.forEach((item) => {
        if (item && item.orderAmount) {
          cont = MathAdd(item.orderAmount, cont);
        }
      });
      cont = Number(cont).toFixed(2);
      this.Recalculation();
      return cont;
    },
    // 实际结算金额总计
    settlementSumTotal () {
      let cont = 0;
      this.productList.forEach((item) => {
        if (item.settlementAmount) {
          cont = MathAdd(cont, item.settlementAmount);
        }
      });
      return cont;
    },
    // 拆分前单价总计
    beProductUnitPriceTotal () {
      let cont = 0;
      this.productList.forEach((item) => {
        let itemcont = MathMulti(item.serviceLife, item.beforeSplitProductPriceSigle);
        cont = MathAdd(itemcont, cont);
      });
      cont = Number(cont).toFixed(2);
      return cont;
    }
  },
  methods: {
    initData () {
    },
    batchSettings () {
      let error = '';
      this.productList.forEach((item) => {
        if (this.allAttribute.time && !(this.departmentCode && (this.departmentCode.includes('000063') || this.departmentCode.includes('000036') || this.departmentCode.includes('000101')))) {
          let nowDateStr = DateToStr(new Date());
          if (new Date(this.allAttribute.time) >= new Date(nowDateStr)) {
            this.$set(item, 'expectedDeliveryDate', this.allAttribute.time);
          } else {
            error = '期望发货日期不能小于当前日期';
          }
        }
        if (this.allAttribute.freight) {
          this.$set(item, 'freightProperty', this.allAttribute.freight);
        }
      });
      if (error) {
        this.$notify.error({
          message: error
        });
      }
    },
    // 合计行的计算
    getSummaries (param) {
      // let allowsum = ['数量', '订单金额', '实际结算金额'];
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '数量') {
          sums[index] = this.AmountTotal;
          return;
        }
        if (column.label === '订单金额') {
          sums[index] = Number(this.computePriceTotal).toFixed(2);
          return;
        }
        if (column.label === '实际结算金额') {
          sums[index] = Number(this.settlementSumTotal).toFixed(2);
          return;
        }
        if (column.label === '拆分前单价') {
          sums[index] = Number(this.beProductUnitPriceTotal).toFixed(2);
        }
      });
      return sums;
    },
    changeAddress (val) {
      // 选择其他地址
      this.address = val;
      this.showAddress = false;
      this.$emit('chooseAddress', val);
    },
    ChangeDatas () {
      // 地址选择 地址源地址列表发生变化，需要用当前地址id 重新查询地址信息
      if (this.address.id) {
        getReceiptAddressInfoModel(this.address.id).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            if (!json.data.isDelete) {
              this.address = json.data;
            } else {
              this.address = {};
            }
          }
        });
      }
    },
    validate () {
      let error = '';
      if (!this.productList.length) {
        error = '请选择产品';
      }
      if (Number(this.beProductUnitPriceTotal) !== Number(this.computePriceTotal)) {
        error = '拆分前单价与订单金额不符';
      }
      this.productList.forEach((item) => {
        this.$delete(item, 'removeVisible');
        this.$delete(item, 'addNew');
        if (!error) {
          if (!item.productCode) {
            error = '存在产品未选产品型号';
          } else if (!item.materialNumberId) {
            error = '存在产品未选择期料号';
          } else if (!item.expectedDeliveryDate && !(this.departmentCode && (this.departmentCode.includes('000063') || this.departmentCode.includes('000036') || this.departmentCode.includes('000101')))) {
            error = '存在产品未选择期望发货日期';
          } else if (!item.freightProperty) {
            error = '存在产品未选择货运属性';
          }
        }
      });
      return new Promise((resolve, reject) => {
        if (error) {
          this.$notify.error({
            message: error
          });
          resolve(false);
        } else {
          resolve({
            productList: this.productList,
            actualSettlementAmount: Number(this.settlementSumTotal).toFixed(2),
            orderSales: this.computePriceTotal
          });
        }
      });
    },
    validateDraft () {
      return new Promise((resolve, reject) => {
        resolve({
          productList: this.productList,
          actualSettlementAmount: Number(this.settlementSumTotal).toFixed(2),
          orderSales: this.computePriceTotal
        });
      });
    },
    getOrderAmount (row) {
      let Amount = MathMulti(row.productNum, row.productPriceSigle);
      row.orderAmount = Number(Amount).toFixed(2);
      return row.orderAmount;
    },
    removeProduct (index) {
      this.$confirm('是否删除该产品?', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let list = this.productList;
        this.productList = [];
        this.$nextTick(() => {
          list.splice(index, 1);
          list.forEach((item) => {
            if (item.itemIndex > index) {
              item.itemIndex = item.itemIndex - 1;
            }
          });
          this.productList = list;
        });
      }).catch(() => {

      });
    },
    copyRow (row, index) {
      let newRow = JSON.parse(JSON.stringify(row));
      newRow.id = null;
      this.productList.splice(index + 1, 0, newRow);
      this.$nextTick(() => {
        for (let i = 0; i < this.productList.length; i++) {
          this.productList[i].itemIndex = i;
        }
      });
    },
    addNewRow () {
      this.productList.push({
        orderAmount: 0,
        settlementAmount: 0,
        materialNumberId: '',
        productNum: 0,
        productPriceSigle: 0,
        beforeSplitProductPriceSigle: 0,
        removeVisible: false,
        addNew: true
      });
    },
    setMaterialNum (row, index) {
      if (!this.contractType) {
        this.$notify.error({
          message: '请先选择订单分类'
        });
        return;
      }
      let productAndMaterialGroup = [];
      let MaterialNumValues = {};
      if (!row) {
        this.productList.forEach((item, index) => {
          if (item.productCode && !item.exclusiveMaterialNumber) {
            productAndMaterialGroup.push({
              productSalesCode: item.productCode,
              productName: item.productName,
              exclusiveMaterial: item.materialNumberId || '',
              productNum: item.productNum,
              isHavePowerCord: item.isHavePowerCord || false,
              isTestOrder: item.isBorrow || false
            });
            MaterialNumValues[item.productCode] = {
              materialNumberId: item.materialNumberId,
              materialUnit: item.materialUnit
            };
          }
        });
      } else {
        if (row.productCode && !row.exclusiveMaterialNumber) {
          productAndMaterialGroup.push({
            productSalesCode: row.productCode,
            productName: row.productName,
            exclusiveMaterial: row.materialNumberId,
            productNum: row.productNum,
            isHavePowerCord: row.isHavePowerCord || false,
            isTestOrder: row.isBorrow || false
          });
          MaterialNumValues[row.productCode] = {
            materialNumberId: row.materialNumberId,
            materialUnit: row.materialUnit
          };
        } else {
          return;
        }
      }
      const { saleTypeCode, soldCountry } = this.form;
      if (!saleTypeCode || saleTypeCode === '') {
        this.$message.error('请选择订单类型');
        return;
      }
      if (!soldCountry || soldCountry === '') {
        this.$message.error('请选择销往区域');
        return;
      }
      let param = {
        contractType: this.form.saleTypeName || '',
        contractNumber: this.form.contractNum,
        contractName: this.form.projectName || '',
        soldCountry: this.form.soldCountry || '',
        // 原有逻辑为: 是否直签 ?  最终客户 : 订货单位
        // 2024/05/08: 更改为直接取订货单位
        orderUnit: this.form.orderUnit,
        materialReqProductVOS: productAndMaterialGroup,
        orderType: this.form.contractType
      };
      this.$refs.MaterialNum.showdialog(param, index, MaterialNumValues);
    },
    chooseMateria ({ list, RowIndex }) {
      if (RowIndex === 'all') {
        let cx = 0;
        this.productList.forEach((pro, index) => {
          let mate = list[index - cx];
          if (pro.productCode === mate.productSalesCode) {
            pro.materialNumberId = mate.selected;
            // 兼容字段materialUnit为空的时候
            pro.materialUnit = mate.materialUnit || '';
            pro.softFlag = mate.softFlag || '';
          }
          if (pro.exclusiveMaterialNumber) {
            cx++;
          }
        });
      } else {
        this.productList[RowIndex].materialNumberId = list[0].selected;
        this.productList[RowIndex].materialUnit = list[0].materialUnit;
        this.productList[RowIndex].softFlag = list[0].softFlag;
      }
    },
    clickBorrow (row, index) {
      if (row.isBorrow) {
        this.productList[index].freightProperty = '20';
      } else {
        this.productList[index].freightProperty = '';
      }
    },
    async Recalculation () {
      await this.$nextTick();
    },
    handleOrderAmount () { // 订单金额合计
      this.productList.forEach((item) => { // 订单金额的合计
        let Amount = MathMulti(item.serviceLife, item.productPriceSigle);
        item.orderAmount = Number(Amount).toFixed(2);
      });
    },
    handleChange () {
      this.handleOrderAmount();
      this.Recalculation();
      this.$emit('change');
    },
    powerCordSpecificationChange (index, val) {
      // 解决试图不更新问题
      this.$delete(this.productList[index], 'powerCordSpecification');
      this.$set(this.productList[index], 'powerCordSpecification', val);
    }
  },
  created () {
    eventBus.$on('changePowerCord', (data) => {
      this.powerCordData = data.powerCordData;
    });
  },
  beforeDestroy () {
    eventBus.$off('changePowerCord');
  },
  watch: {
    computePriceTotal (val) {
      this.form.contractSum = val;
    },
    productList (val) {
      this.departmentCode = this.form.departmentCode || '';
      for (var i = 0; i < val.length; i++) {
        if (val[i] === null) {
          val.splice(i, 1);
        } else {
          if (!val[i].expectedDeliveryDate) {
            val[i].expectedDeliveryDate = null;
          }
          if (!val[i].expectedShippingDate) {
            val[i].expectedShippingDate = null;
          }
          if (!val[i].expectedArrivalDate) {
            val[i].expectedArrivalDate = null;
          }
        }
      }
      this.Recalculation();
    },
    isTestProject () {
      this.Recalculation();
    },
    salesType () {
      this.Recalculation();
    },
    communicationOrderDiscount () {
      this.Recalculation();
    }
  },
  mounted () {
    this.isShowInternationalServiceOrders = Number(this.$route.query.isShowInternationalService);
  }
};
</script>
<style lang="scss" scoped>
.productTable{
  .el-table__footer-wrapper tbody td{
    background: #fff;
  }
}
.adressBox{
  display: inline-block;
  .item{
    display: inline-block;
    margin-right: 6px;
  }
  .defTab{
    padding: 3px 10px;
    display: inline-block;
    background: #1b73ff;
    font-size: 12px;
    color: #fff;
    border-radius: 4px;
    margin-right: 15px;
  }
}
.table{
  background: #00ff00;
}
</style>
